import { ComponentProps, useMemo } from 'react'

import FormikLabeledAutoComplete from '~/components/formikFields/formikLabeledAutocomplete'
import { DEFAULT_SERVICE_NAME } from '~/features/settings/constants'
import useGetServiceTemplates from '~/features/templates/hooks/useGetServiceTemplates'

type TProps = Omit<
  ComponentProps<typeof FormikLabeledAutoComplete>,
  'meta' | 'isLoading' | 'options'
>

function FormikServiceAutocomplete({
  freeSolo = true,
  label = 'Service',
  placeholder = 'Painter, Plumber, Window Repair...',
  ...props
}: TProps) {
  const { data: serviceTemplates, isLoading } = useGetServiceTemplates({
    active: true,
  })

  const options = useMemo(
    () =>
      (serviceTemplates?.data || [])
        .filter(
          (serviceTemplate) => serviceTemplate.service !== DEFAULT_SERVICE_NAME,
        )
        .map((serviceTemplate) => ({
          label: serviceTemplate.service,
          value: serviceTemplate.service,
        })),
    [serviceTemplates?.data],
  )

  return (
    <FormikLabeledAutoComplete
      freeSolo={freeSolo}
      isLoading={isLoading}
      label={label}
      meta={{
        isLoading,
        options,
      }}
      options={options}
      placeholder={placeholder}
      {...props}
    />
  )
}

export default FormikServiceAutocomplete
